import React from 'react'

import DataFetchingTableTable from '../../../../DataFetchingTableTable'

import { StyledWrapper } from './styles'

const ConversionsListTable = ({ header, pagination, fetchData, refetch }) => (
  <StyledWrapper>
    <DataFetchingTableTable
      sortableHeaders={[]}
      showSearch={false}
      filters={[]}
      header={header}
      resultsPerPage={pagination}
      footer={[]}
      fetchData={fetchData}
      refetch={refetch}
    />
  </StyledWrapper>
)

export default ConversionsListTable
